"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserServiceImpl = void 0;
var Utils_1 = require("../utils/Utils");
var UserProviderImpl_1 = require("./provider/firebase/UserProviderImpl");
var UserProviderImpl_2 = require("./provider/airabbi/UserProviderImpl");
var UserServiceImpl = (function () {
    function UserServiceImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.timeText)(Date.now()), " UserServiceImpl#")], args, false));
            }
        };
        this.error = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).error.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.timeText)(Date.now()), " UserServiceImpl#")], args, false));
            }
        };
        this.info = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).info.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.timeText)(Date.now()), " UserServiceImpl#")], args, false));
            }
        };
        this.getAllUsers = function () {
            return _this.provider.getAllUsers();
        };
        this.getAllUnits = function () {
            return _this.provider.getAllUnits();
        };
        this.getMultiUsers = function (uidList) {
            return _this.provider.getMultiUsers(uidList);
        };
        this.getAllUsersByUnitPagination = function (skip, limit, searchType, sort, searchString, role, unit) {
            return _this.provider.getAllUsersByUnitPagination(skip, limit, searchType, sort, searchString, role, unit);
        };
        this.getUsersByUnitPagination = function (skip, limit, searchType, sort, searchString, role) {
            return _this.provider.getUsersByUnitPagination(skip, limit, searchType, sort, searchString, role);
        };
        this.createUser = function (user) {
            return _this.provider.createUser(user);
        };
        this.getStaffs = function () { return _this.provider.getStaffs(); };
        this.getStudents = function () { return _this.provider.getStudents(); };
        this.getTeachers = function () { return _this.provider.getTeachers(); };
        this.removeUser = function (user) { return _this.provider.removeUser(user); };
        this.sendPasswordResetEmail = function (user) {
            return _this.provider.sendPasswordResetEmail(user);
        };
        this.sendVerificationEmail = function (user) {
            return _this.provider.sendVerificationEmail(user);
        };
        this.updateUser = function (user) { return _this.provider.updateUser(user); };
        this.queryUser = function (uid) { return _this.provider.queryUser(uid); };
        this.removeOthers = function () { return _this.provider.removeOthers(); };
        this.stopAllMonitor = function () { return _this.provider.stopAllMonitor(); };
        this.onActive = function () { return _this.provider.onActive(); };
        this.getSignUpUsers = function () { return _this.provider.getSignUpUsers(); };
        this.querySignUpUser = function (email) { return _this.provider.querySignUpUser(email); };
        this.signUp = function (user) { return _this.provider.signUp(user); };
        this.getCodingbarDomainAccessUnitList = function () {
            return _this.provider.getCodingbarDomainAccessUnitList();
        };
        this.insertCodingbarDomainAccessUnitList = function (unit) {
            return _this.provider.insertCodingbarDomainAccessUnitList(unit);
        };
        this.removeCodingbarDomainAccessUnitList = function (unit) {
            return _this.provider.removeCodingbarDomainAccessUnitList(unit);
        };
        this.log('created#');
        switch (cfg.provider) {
            case 'firebase':
                this.provider = new UserProviderImpl_1.UserProviderImpl(cfg);
                break;
            case 'airabbi':
                this.provider = new UserProviderImpl_2.UserProviderImpl(cfg);
                break;
        }
    }
    UserServiceImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        return this.provider.init(env);
    };
    UserServiceImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
        return this.provider.setDebuggable(debuggable);
    };
    return UserServiceImpl;
}());
exports.UserServiceImpl = UserServiceImpl;
//# sourceMappingURL=UserServiceImpl.js.map